export class SequenceWaiter {
    constructor(name) {
        this.sequence = 0;
        this.pendingActions = new Map();
        this.name = name;
    }
    setAction(t) {
        const sequence = this.sequence;
        this.pendingActions.set(sequence, t);
        ++this.sequence;
        return sequence;
    }
    unsetAction(sequence) {
        const action = this.pendingActions.get(sequence);
        this.pendingActions.delete(sequence);
        return action;
    }
}
